<script>
  import GraphMediaFipe from './MediaFipe'
  export default {
    name: 'relatorio-basico-result',
    props: ['data', 'type', 'period'],
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {GraphMediaFipe}
  }
</script>

<template>
  <div class="result bg-black dker">
    <div class="result-title">
      <h1>RELATÓRIO MÉDIA DE RECUPERAÇÃO X FIPE</h1>
      <h2>{{type}}</h2>
      <h3>{{period}}</h3>
    </div>
    <div class="line-graph">
      <div class="col1">
        <table class="tbl-result">
          <thead>
          <tr>
            <th>Comitente</th>
            <th class="text-center">% FIPE</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="v in data">
            <td>{{v.comitente}}</td>
            <td class="text-center">{{v.percentualFipe}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col2">
        <graph-media-fipe :data="data"/>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Result.vue?6ac73c0c